import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import React, { type FC } from 'react';

interface AutocompleteOptionsProps {
  option: string;
  value: string;
}

const AutocompleteOptions: FC<AutocompleteOptionsProps> = ({ option, value, ...props }) => {
  const matches = match(option, value, { insideWords: true });
  const parts: Array<{ text: string; highlight: boolean }> = parse(option, matches);
  return (
    <li {...props}>
      <div>
        {parts.map((part, index) => (
          <span
            key={`${part.text}-${index}-${part.highlight}`}
            style={{
              fontWeight: part.highlight ? 700 : 400,
            }}
          >
           {part.text}
           </span>
        ))}
      </div>
    </li>
  );
};

export default AutocompleteOptions;
